const INVALID_VALUE_MSG = 'Enter a valid value';
const INVALID_CHARACTERS_MSG = 'Enter valid characters';

export { INVALID_VALUE_MSG, INVALID_CHARACTERS_MSG };
